const Teacher_list = () =>import ('../views/teacher_list/teacher_list.vue')
const Teacher_detail = ()=>import('../views/teacher_list/teacher_detail.vue')

export default [
    {
        path:'/teacher_list',
        name:"teacher_list",
        component:Teacher_list,
        meta: {
            keepAlive: true
        }
    },
    {
        path:'/teacher_detail/:id',
        name:"teacher_detail",
        component:Teacher_detail,
        meta: {
            keepAlive: true
        }
    },
]